import React from "react";
import ResourceDetailsStore from "../stores/resource-details-store";
import Dispatcher from "../dispatcher";
import Utils from "../utils/utils";
import { VstLoader } from "vstui";
import { Table, Button } from "@vitalsource/vstui";

class Resource extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      resource: this._filterAncillaries(
        ResourceDetailsStore.get(props.isbn)
      ),
      downloadSupported: false
    };
  }

  componentDidMount() {
    Dispatcher.on(Dispatcher.RESOURCE_DETAILS_STORE_CHANGE, this._handleChange);
    this._checkDownloadAttrSupport();
  }

  componentWillUnmount() {
    Dispatcher.removeListener(
      Dispatcher.RESOURCE_DETAILS_STORE_CHANGE,
      this._handleChange
    );
  }

  _handleChange = () => {
    this.setState({
      resource: this._filterAncillaries(
        ResourceDetailsStore.get(this.props.isbn)
      )
    });
  }

  _checkDownloadAttrSupport = () => {
    // For now, disable Firefox as well, since it technically allows the download
    // attribute, but ONLY from same origin (not AWS)
    let a = document.createElement("a");

    var browser = navigator.userAgent.toLowerCase();
    let isFirefox = browser.indexOf("firefox") > -1 ? true : false;

    if (typeof a.download != "undefined" && !isFirefox) {
      this.setState({
        downloadSupported: true
      });
    }
  }

  _downloadAll = () => {
    const anchors = document.getElementsByClassName("file-download");
    const download = (anchor, count) => {
      if (anchor) {
        anchor.click();
      }
      count++;
      if (count < anchors.length) {
        setTimeout(() => {
          download(anchors[count], count);
        }, 100);
      }
    };

    setTimeout(() => {
      download(anchors[0], 0);
    }, 1000);
  }

  _filterAncillaries(data) {
    if (data && data.ancillaries.length > 0) {
      data.ancillaries = data.ancillaries.filter((item, index) => {
        if (item.type !== "accesscode") {
          item.name = item.title;
          if (item.type === "url") {
            item.typeDisplay = "URL";
            item.size = "-";
            item.action = (
              <a href={item.href} target="_blank">
                {i18n.t("base.launch")}
              </a>
            );
          } else if (item.type === "file") {
            item.typeDisplay = this._getFileExtension(item.href).toUpperCase();
            item.action = (
              <a
                href={item.href}
                target="_blank"
                className="file-download"
                download=""
              >
                {i18n.t("base.download")}
              </a>
            );
          } else {
            item.typeDisplay = "-";
            item.action = (
              <a href={item.href} target="_blank">
                {i18n.t("base.launch")}
              </a>
            );
          }

          return item;
        }
      });
    }
    return data;
  }

  _getFileExtension(url) {
    return url
      .split("?")[0]
      .split(".")
      .pop();
  }

  renderTable() {
    const { resource } = this.state;
    const count = resource ? resource.ancillaries.length : "";
    const tableHeaders = [
      {
        header: i18n.t("resources.name"),
        numeric: false,
        hiddenHeader: false,
        rowKey: "name"
      },
      {
        header: i18n.t("resources.type"),
        numeric: false,
        hiddenHeader: false,
        rowKey: "type"
      },
      {
        header: i18n.t("resources.size"),
        numeric: false,
        hiddenHeader: false,
        rowKey: "size"
      },
      { header: "", numeric: false, hiddenHeader: false, rowKey: "action" }
    ];

    let tableRows = [];

    if (resource) {
      tableRows = resource.ancillaries.map(ancillary => {
        return {
          name: ancillary.name || "",
          type: ancillary.typeDisplay || "",
          size: ancillary.size || 0,
          action: ancillary.action
        };
      });
    }

    if (!resource) {
      return (
        <div className="deck resource-list">
          <VstLoader />
        </div>
      );
    } else if (tableRows.length < 1) {
      return (
        <div className="deck resource-list">
          {i18n.t("resources.no-ancillaries")}
        </div>
      );
    }
    return <Table columns={tableHeaders} rows={tableRows} fullWidth />;
  }

  render() {
    const { resource, downloadSupported } = this.state;
    const count = resource ? resource.ancillaries.length : "";
    const title = resource ? resource.title : "";
    const downloadAll = downloadSupported && (
      <Button naked className="download-all" onClick={this._downloadAll}>
        {i18n.t("resources.download-all")}
      </Button>
    );
    const table = this.renderTable();

    return (
      <div className="page resources">
        <header>
          <a className="arrow-back-button" href="#/resources">
            <img
              src={require("../../img/arrow_left.svg")}
              alt={i18n.t("resources.back")}
            />
          </a>
          <h1 className="resource-title">
            {count} {i18n.t("resources.ancillaries")}
            <span className="not-link">
              {i18n.t("resources.in")} {Utils.toHTML(title)}
            </span>
          </h1>
          {downloadAll}
        </header>
        {table}
      </div>
    );
  }
}

export default Resource;
